import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

const Landing = lazy(() => import("@/pages/Landing"));
const Tool = lazy(() => import("@/pages/Tool"));
const About = lazy(() => import("@/pages/About"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const Terms = lazy(() => import("@/pages/Terms"));

function Boot() {
  return (
    <div className="min-h-screen flex items-center justify-center text-muted-foreground font-mono text-xs uppercase tracking-[0.22em]">
      Loading…
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false} storageKey="jfl-theme">
        <div className="App">
          <BrowserRouter>
            <Suspense fallback={<Boot />}>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/tool" element={<Tool />} />
                <Route path="/about" element={<About />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="*" element={<Landing />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
          <Toaster position="bottom-right" />
        </div>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
